import { Modal, Button, Typography } from "antd";
import React, { useState } from "react";
import { RiDeleteBinFill } from "react-icons/ri";
import axios from "axios";
import { Error, Success } from "../../../commons/Messages/Messages";
import { useTranslation } from "react-i18next";
const { Text } = Typography;

// The server removes the board together with its groups, tickets and their tasks.
const DeleteBoardModal = ({ data, updateParent, onOpen }) => {
  const { t } = useTranslation("dashboard");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const deleteBoard = async () => {
    setLoading(true);
    try {
      const res = await axios.delete(
        `${process.env.REACT_APP_BACKEND_URL}/ticketBoards/delete/${data._id}`,
        { headers: { Authorization: "Bearer " + localStorage.getItem("token") } }
      );
      Success(t(res.data.successMessage));
      setIsModalOpen(false);
      updateParent?.();
    } catch (err) {
      Error(err.response?.data?.errorMessage || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button
        type="text"
        danger
        icon={<RiDeleteBinFill />}
        block
        onClick={() => {
          onOpen?.();
          setIsModalOpen(true);
        }}
      >
        {t("Delete Board")}
      </Button>
      <Modal
        title={
          <div className="tkt-modal-title">
            <span>{t("Delete Board")}</span>
            <span className="tkt-modal-subtitle">{t("This action cannot be undone.")}</span>
          </div>
        }
        open={isModalOpen}
        onOk={deleteBoard}
        onCancel={() => setIsModalOpen(false)}
        confirmLoading={loading}
        okText={t("Delete")}
        cancelText={t("Cancel")}
        okButtonProps={{ danger: true }}
        centered
        width={440}
        rootClassName="tkt-modal"
      >
        <Text>
          {t("Delete this board with all its groups, tickets and tasks?")}{" "}
          <Text strong type="danger">
            {data.title}
          </Text>
        </Text>
      </Modal>
    </>
  );
};

export default DeleteBoardModal;
